import {type AxiosPromise} from 'axios';
import {createActions, handleActions} from 'redux-actions';
import {FULFILLED, PENDING} from 'redux-promise-middleware';
import FormData from 'form-data';

import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

import {IMAGE_WIDTH, IMAGE_HEIGHT} from '../../constants/constants';
import type {TryOnFaceType} from '../collection';
import type {TryOnPhotoType} from '../photo';
import type {TryOnSettingsType} from './settingsType';

export const defaultState: TryOnSettingsType = {
    status: FULFILLED,
};

export const {
    tryOn: {handlerUpdateFaceSettings, updateFaceSettings},
} = createActions({
    TRY_ON: {
        /**
         * Handler "Update face settings" for saga
         */
        HANDLER_UPDATE_FACE_SETTINGS: () => {},

        /**
         * Update face settings
         * @param {TryOnFaceType} collection - Collection data of TryOn
         * @param {TryOnPhotoType} photo - Photo data of TryOn
         * @param {'women' | 'men' | 'kids'} gender - current gender
         * @return {AxiosPromise} Axios promise
         */
        UPDATE_FACE_SETTINGS: (
            collection: TryOnFaceType,
            photo: TryOnPhotoType,
            gender,
        ): AxiosPromise => {
            const data = new FormData();
            const formData = {
                canvas_width: IMAGE_WIDTH,
                canvas_height: IMAGE_HEIGHT,
                x: 0,
                y: 0,
                scale: '1.0',
                rotate: '0',
                center_x: false,
                center_y: false,
                pupil_left_x: photo.pupils.left.x,
                pupil_left_y: photo.pupils.left.y,
                pupil_right_x: photo.pupils.right.x,
                pupil_right_y: photo.pupils.right.y,
                pd: collection.pd,
                gender,
            };

            Object.keys(formData).forEach((key: string) => {
                data.append(key, formData[key]);
            });

            return instanceGusaBackend({
                headers: {'Content-Type': 'multipart/form-data'},
                method: 'post',
                url: ENDPOINTS.TRYON_SET_ADJUST,
                data,
            });
        },
    },
});

export const settings = handleActions(
    {
        /**
         * Set pending status for change settings data
         * @return {TryOnSettingsType} New state
         */
        [handlerUpdateFaceSettings]: () => ({status: PENDING}),

        /**
         * Set pending status for fetching settings data
         * @return {TryOnSettingsType} New state
         */
        [`${updateFaceSettings}_${PENDING}`]: () => ({status: PENDING}),

        /**
         * Set fulfilled status for fetching settings data
         * @return {TryOnSettingsType} New state
         */
        [`${updateFaceSettings}_${FULFILLED}`]: () => ({status: FULFILLED}),
    },
    defaultState,
);
